import React, { useEffect, useState } from "react";
import {
  Helpers,
  Providers,
  ReactMFE,
} from "@tpd-web-common-libs/nodejs-library";
import styled from "@emotion/styled";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";

const App = (props) => {
  const { __host__ } = props;

  const [layer] = useState(() => {
    if (
      Helpers.EnvironmentHelper.isClientSide() &&
      window.location.href.indexOf("area_riservata/telematica-casa")
    ) {
      window["utag_cfg_ovrd"] = {
        noview: true,
      };
    }

    const routerService = Providers.RouterService.getInstance();
    const dataLayer = {
      page_name: __host__?.datalayerInfo?.pageName || "",
      page_id: __host__?.datalayerInfo?.pageId || "",
      issue_date: __host__?.datalayerInfo?.issueDate || "",
      primary_category: __host__?.datalayerInfo?.primaryCategory || "",
      subject_category: __host__?.datalayerInfo?.subjectCategory || "",
      network_source: __host__?.datalayerInfo?.networkSource || "",
      site_agency_area: __host__?.pageProperties?.site_agency_area || "",
      site_agency_id: __host__?.pageProperties?.site_agency_id || "",
      page_environment: "prod", // TODO - make dynamic
      referring_url: routerService.getReferringUrl(),
      page_company: "unipolsai",
      functional_category: __host__?.pageProperties?.functional_category || "",
    };

    const analyticsService = Providers.AnalyticsService.getInstance();
    analyticsService.updateSourceDataLayer(dataLayer);

    return dataLayer;
  });

  return (
    <div
      className={Helpers.AnalyticsHelper.SOURCE_DATA_LAYER_CLASS}
      data-datalayer={Helpers.AnalyticsHelper.stringifyDataLayer(layer)}
    />
  );
};

export default ReactMFE.PrimaryRemoteHOCFactory(
  React,
  styled,
  { CacheProvider },
  createCache
)(App);
